import { render, staticRenderFns } from "./ShapeLinks.vue?vue&type=template&id=ce17daf8"
import script from "./ShapeLinks.vue?vue&type=script&lang=js"
export * from "./ShapeLinks.vue?vue&type=script&lang=js"
import style0 from "./ShapeLinks.vue?vue&type=style&index=0&id=ce17daf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports